<template>
  <InfoHeader v-if="profile">
    <template v-if="!profile.isOwn">My Social Space</template>
    <template v-else>
      <div :class="$style.avatarWrap">
        <img
          :src="profile.picture" alt="profile picture"
          :class="$style.image"
        >
      </div>
      <div :class="$style.title">{{ profile.firstName }} {{ profile.lastName }}</div>
    </template>
    <template slot="action">
      <div v-if="profile.isOwn" :class="['action-button', $style.followersBtnWrap]">
        <BaseIcon name="users" @click="showSubscribers" />
        <div v-if="profile.pending" :class="$style.followersBtnCounter">{{ profile.pending }}</div>
      </div>
      <BaseIcon custom name="share" class="action-button" @click="onShare" />
      <BaseIcon name="search" class="action-button" @click="showSearch" />
    </template>
  </InfoHeader>
</template>

<script>
import InfoHeader from '@/components/InfoHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'social-info-header',
  props: {
    profileNickname: String
  },
  components: {
    InfoHeader
  },
  computed: {
    ...mapGetters({
      profileById: 'entities/socialProfiles/getProfile'
    }),
    profile () {
      return this.profileById(this.profileNickname)
    }
  },
  methods: {
    onShare () {
      const link = window.location.origin + this.$route.path
      this.$modal.show('share-to-chat', {
        value: link,
        text: link
      })
    },
    showSubscribers () {
      this.$modal.show('social-profile-subscriptions', { profileNickname: this.profileNickname })
    },
    showSearch () {
      this.$modal.show('social-search')
    }
  }
}
</script>

<style module lang="scss">
.avatarWrap {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  overflow: hidden;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.title {
  margin-left: 12px;
}
.followersBtnWrap {
  position: relative;
}

.followersBtnCounter {
  position: absolute;
  border-radius: 8px;
  background-color: $text-error;
  color: $text-lightest;
  font-size: 10px;
  padding: 2px 4px;
  top: -6px;
  left: 18px;
  text-align: center;
  min-width: 16px;
  font-weight: 600;
}
</style>
